module.exports = __webpack_public_path__ + "static/media/macbook-624707.264bf4e0.jpg";